export const LISTING_TYPES = {
    longlet: "Long Let",
    shortlet: "Short Let",
    sale: "Sale"
}